import { z } from "zod";

import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { MetaSchema } from "@shared/content-types/schemas/pagination.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

export const WebCamsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  titleWithIcon: TitleWithIconSchema,
  heroDescription: z.string().min(1),
  seo: SeoSchema.optional().nullable(),
});

export const WebCamsTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
});

export const WebCamSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  title: z.string().min(1),
  shortName: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  web_cams_types: z.array(WebCamsTypeSchema).min(0),
  inLive: z.boolean(),
  camLink: z.string().min(1),
  mountainHeight: z.string().min(1),
  description: z.string().min(1).optional(),
  uid: z.string().min(1),
  previewImage: StrapiMediaSchema,
  cameraPosition: StrapiMediaSchema,
  rotateCompas: z.number().positive(),
  coordinates: z.string(),
  imageForScoreboard: StrapiMediaSchema,
  viewImageForScoreboard: z.boolean(),
  cameraDetail: z.object({
    id: z.number().int().positive(),
    length: z.string().min(1),
    heightDif: z.string().min(1),
    complexity: z.string().min(1),
    statusCam: z.string().min(1),
  }),
});

export const WebCamsPageDtoSchema = z.object({
  data: WebCamsPageSchema,
});

export const WebCamsDtoSchema = z.object({
  data: z.array(WebCamSchema).min(0),
  meta: MetaSchema,
});

export const WebCamTypesDtoSchema = z.object({
  data: z.array(WebCamsTypeSchema).min(0),
  meta: MetaSchema,
});
